import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { toast } from 'sonner';

const useGoogleAuth = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const errorMessage = searchParams.get('error');
    const successMessage = searchParams.get('success');

    if (errorMessage) {
      searchParams.delete('error');
      setSearchParams(searchParams);
      toast.error(errorMessage);
    }

    if (successMessage) {
      searchParams.delete('success');
      setSearchParams(searchParams);
      toast.success(successMessage);
    }
  }, [searchParams, setSearchParams]);
};

export default useGoogleAuth;
